import { fetchAnswers } from '../../services/answers';
import { TThunkAction } from '../../types/redux';
import { addAnswersToReview } from '../reviews';
import { setAnswers } from './actions';

interface IParams {
  reviewId: string;
  page: number;
}

export function loadAnswers({ reviewId, page }: IParams): TThunkAction<Promise<boolean>> {
  return async (dispatch, getState, context) => {
    const { logger, httpApi } = context;

    try {
      const { answers, answerIds, hasMore } = await fetchAnswers({
        httpApi,
        parameters: { page, reviewId },
      });

      dispatch(setAnswers(answers));
      dispatch(addAnswersToReview({ answerIds, reviewId, hasMore, answersPage: page }));

      return true;
    } catch (error) {
      logger.error(error, {
        domain: 'answers#loadAnswers',
        message: error.message,
      });

      return false;
    }
  };
}
